/*
 * @Date: 2019-08-21 17:00:28
 * @LastEditors: x
 * @LastEditTime: 2021-09-30 11:41:03
 */
import qs from 'qs'
import store from '../store'
import baseConfig from './config'
import axios from 'axios'
import router from '../router'

let lock = false
const pending = []
const CancelToken = axios.CancelToken
const removePending = (key, isRequest = false) => {
  if (pending[key] && isRequest) {
    pending[key]('取消重复请求')
    lock = true
  }
  delete pending[key]
}
const getRequestIdentify = (config, isRequest = false) => {
  let url = config.url
  if (isRequest) {
    url = config.baseURL + config.url.substring(1, config.url.length)
  }
  return config.method === 'get' ? encodeURIComponent(url + JSON.stringify(config.params))
    : encodeURIComponent(config.url + JSON.stringify(config.data))
}

// 添加请求拦截器
baseConfig.interceptors.request.use(config => {
  // 在发送请求之前
  // 拦截重复请求(当前正在进行的相同请求)
  let requestData = getRequestIdentify(config, true)
  removePending(requestData, true)
  config.cancelToken = new CancelToken(c => {
    pending[requestData] = c
  })
  return config
}, err => {
  // 请求错误
  return Promise.reject(err)
})

// 添加响应拦截器
baseConfig.interceptors.response.use(response => {
  //响应成功
  //把已经完成的请求从pending中移除
  let requestData = getRequestIdentify(response.config)
  removePending(requestData)
  return response.data
}, err => {
  //响应错误
  if (lock) {
    lock = false
    return
  }
  // store.commit('HIDE_LOADING')
  if (axios.isCancel(err)) {
    // 为了终结promise链 就是实际请求 不会走到.catch(rej=>{});这样就不会触发错误提示之类了。
    return new Promise(() => { });
  } else {
    let status = err.response.status
    checkStatus(status)
    return Promise.reject(err)
  };
})

// 检查响应状态
const checkStatus = status => {
  switch (status) {
    case 401:
      console.log('未登录')
      router.replace('/login')
      break;
    case 403:
      console.log('登录过期')
      break;
    case 404:
      console.log('资源不存在')
      break;
  }
}

// 抛出请求方式
export default {
  get(url) {
    return baseConfig.get(url)
  },
  post(url, data) {
    return baseConfig.post(url, qs.stringify(data))
  },
  put(url, data) {
    return baseConfig.put(url, qs.stringify(data))
  },
  delete(url) {
    return baseConfig.delete(url)
  }
}


// WEBPACK FOOTER //
// ./src/api/api.js